export const LAYERS_ARIA_ID = 'layers_aria'
export const LAYER_ITEM_CONTAINER_CLASSNAME = 'layer-item-container'
export const LAYER_CONTROL_WIDTH = 64
export const LAYERS_CONTROL_RIGHT_X = 94
export const SCROLLBAR_RIGHT_X_REDUCING_DELTA = 30
export const LAYERS_MAX_X_SCROLL_SPEED = 25
export const LAYERS_MIN_X_SCROLL_SPEED = 15
export const LAYERS_Y_SCROLL_SPEED = 5
